import { Box } from '@mui/material';
import { PoolButton } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SearchNotFoundIcon, SortingArrowLeftIcon } from '@synergy/theme-next';
import { useNavigate } from 'react-router';

import { EmptyState } from '../../components/empty-state/empty-state';
import { EmptyStateActions } from '../../components/empty-state/empty-state-actions';
import { EmptyStateContent } from '../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../components/empty-state/empty-state-title';
import { ROUTES } from '../../utils/routes';

export const ErrorPage = (): ReactElement => {
    const navigate = useNavigate();

    const handleBackToShopClick = (): void => {
        navigate(ROUTES.coverPage);
    };

    return (
        <Box sx={{ py: 22, margin: 'auto' }}>
            <EmptyState icon={<SearchNotFoundIcon fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.empty.error.404.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage id="app.empty.error.404.text" />
                </EmptyStateContent>
                <EmptyStateActions>
                    <PoolButton
                        variant="contained"
                        startIcon={<SortingArrowLeftIcon />}
                        onClick={handleBackToShopClick}
                    >
                        <PoolFormattedMessage id="app.empty.button.backToShop" />
                    </PoolButton>
                </EmptyStateActions>
            </EmptyState>
        </Box>
    );
};
